export default {
    // 模板导出
    exportModel(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/exportModelFile', params, response);
    },
    // 模板信息查询接口
    queryTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/queryTemplate', params, response);
    },
    // 模板删除接口
    deleteTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/deleteTemplate', params, response);
    },
    // 模板停用接口
    stopEnabled(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/suspendTemplate', params, response);
    },
    // 模板上传接口
    uploadTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/uploadTemplate', params, response);
    },
    // 模板启用接口
    immediatelyEnable(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/activateTemplate', params, response);
    },
    // 新建流程图
    newModel(params, response) {
        window.vue.$apiAxios.post('/models/newModel', params, response);
    },
    // 获取流程用户任务节点信息
    getNodeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getTaskList', params, response);
    },
    // 消息中间件信息查询接口
    listUserInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getAllUsers', params, response);
    },
    // 查询角色
    listRoleInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleAuthList', params, response);
    },
    // 保存角色节点关联关系
    saveNodeUser(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/saveNodeUser', params, response);
    },
    // 查询操作按钮信息
    getMenuList(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getMenuList', params, response);
    },
    // 流程启用接口
    submitLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/submitLeaveBill', params, response);
    },
    // 保存操作按钮信息
    saveMenuList(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/saveMenuList', params, response);
    },
    // 查询分配用户
    queryNodeUser(params, response) {
        window.vue.$apiAxios.postRequestBody('/templateManage/getNodeUser', params, response);
    }
};
